import { Link, Outlet } from '@tanstack/react-router';
import styles from './AppShell.module.css';

export const navigation = [
  { to: '/', label: 'Inicio' },
  { to: '/playground', label: 'Playground' },
  { to: '/historial', label: 'Historial' },
  { to: '/asistentes', label: 'Asistentes' },
  { to: '/biblioteca', label: 'Biblioteca' },
  { to: '/cuenta', label: 'Cuenta' },
] as const;

export function AppShell() {
  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <img
          className={styles.logo}
          src="/brand/ailab-logo.svg"
          alt="AILAB"
          width={120}
          height={35}
        />
        <nav className={styles.nav} aria-label="Navegación principal">
          {navigation.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={styles.link}
              activeProps={{ className: `${styles.link} ${styles.active}`, 'aria-current': 'page' }}
              activeOptions={{ exact: item.to === '/' }}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </aside>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
